/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { UserContext } from '@irian-ro/auth-shared-module';
import { getSignupRights } from '@well/rights';
import { SignupStepService } from '../signup-wizard-feature/service/signup-step.service';

export const signupGuard: CanActivateFn = (_, state) => {
  const userContext = inject(UserContext);
  const router = inject(Router);
  const signupStep = inject(SignupStepService);

  if (userContext.hasExactRights(getSignupRights())) {
    return signupStep.getUrlToNextSignupStep().pipe(
      take(1),
      map((nextUrl: string) => {
        if (state.url.toString() === nextUrl) {
          return true;
        }
        return router.parseUrl(nextUrl);
      })
    );
  }
  return true;
};
